import logo from "../../assets/chinook_white.png";
import "./navbar.css";

import GradButton from "../Button/GradButton/GradButton";
import NavButton from "../Button/NavButton/NavButton";
import { useMsal } from "@azure/msal-react";

import { Link } from "react-router-dom";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import paths from "../../api/paths.api";

function HomeNavbar() {
  const loc = useLocation();

  const divider = ".";
  const auth = useMsal().accounts[0]?.name;
  console.log("auth", useMsal().accounts[0]?.name);

  return (
    <div className="nav-container">
      <Link to="/">
        <div className="logo">
          <img src={logo} alt="ChinookDT logo" width={130} />
        </div>
      </Link>
      <div className="nav-items">
        <NavButton
          text="Digital Transformation"
          route="/"
          isSelected={loc.pathname == "/" ? true : false}
        />
        <div className="divider">{divider}</div>
        {/* <NavButton
          text="EPCM"
          route={paths.epcmPage}
          isSelected={loc.pathname == paths.epcmPage ? true : false}
        />
        <div className="divider">{divider}</div>
        <NavButton
          text="DEMO"
          route={paths.demoPath}
          isSelected={loc.pathname == paths.demoPath ? true : false}
        />
        <div className="divider">{divider}</div>
        <NavButton
          text="ON BOARDING"
          route={paths.onBoardingPath}
          isSelected={loc.pathname == paths.onBoardingPath ? true : false}
        />
        <div className="divider">{divider}</div> */}
        <NavButton
          text="Software"
          route={paths.softwarePage}
          isSelected={loc.pathname == paths.softwarePage ? true : false}
        />
      </div>
      {auth ? (
        <div className="nav-end">
          <NavButton
            text="projects"
            route={paths.myProjects}
            isSelected={loc.pathname == paths.myProjects ? true : false}
          />
          <GradButton text="logout" />
        </div>
      ) : (
        <div className="nav-end">
          <NavButton
            text="Contact Us"
            route={paths.contactPage}
            isSelected={loc.pathname == paths.contactPage ? true : false}
          />
          <GradButton text="Login" route={paths.loginPath} />
        </div>
      )}
    </div>
  );
}

export default HomeNavbar;
